import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const Wrapper = styled(Box)({
  maxWidth: 1200,
  minWidth: 1000,
  margin: '0 auto',
  padding: 40,
  minHeight: 'calc(100vh - 100px)',
});
